import EvaluatorItem from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorItem.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import EvaluatorSearchParams from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorSearchParams';
import EvaluatorPersonaAndSchedulingSearchParams from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorPersonaAndSchedulingSearchParams';
import EvaluatorEmailCampaignExportSearchParams from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorEmailCampaignExportSearchParams';
import EvaluatorTextMessageExportSearchParams from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorTextMessageExportSearchParams';

export default class EvaluatorService {
  static GetTipaltiExportFile() {
    const url = '/api/Evaluator/GetTipaltiExportFile/';
    return AuthService.getInstance().CallBackendFunctionGetFile(url);
  }

  static GetEvaluatorList(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/Evaluator/GetEvaluators/?searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static ConvertDBEvaluator(Items) {
    const convertedItems = [];

    if (Items !== null) {
      Items.forEach((item) => {
        const newItem = new EvaluatorItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetPersonaExportEvaluators(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorPersonaAndSchedulingSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/Evaluator/GetPersonaExportEvaluatorsAsync/?searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static GetEmailCampaignExportEvaluators(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorEmailCampaignExportSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/Evaluator/GetEmailCampaignExportEvaluatorsAsync/?searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static GetTextMessageExportEvaluators(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorTextMessageExportSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/Evaluator/GetTextMessageExportEvaluatorsAsync/?searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static GetSchedulingExportEvaluators(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(
      searchItem,
      EvaluatorPersonaAndSchedulingSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/Evaluator/GetSchedulingExportEvaluatorsAsync/?searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static async EditEvaluator(editedEvaluator) {
    const evaluatorData = EvaluatorItem.CreateEditedEvaluatorJSONObject(editedEvaluator);

    const url = `api/Evaluator/PutEvaluator/${editedEvaluator.EvId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, evaluatorData);
  }

  static async PostForceEvaluatorUploadToTpInstance(forcedEvaluatorData) {
    const jsonData = JSON.stringify(forcedEvaluatorData);

    const url = 'api/ForcedEvaluatorUpload/PostForceEvaluatorUploadToTpInstance';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, jsonData);
  }

  static GetTipaltiEvaluatorData(idap) {
    return AuthService.getInstance().CallBackendFunction(`/api/Evaluator/GetTipaltiPayeeData/?idap=${idap}`);
  }

  static GetEvaluatorNameById(id) {
    const authService = AuthService.getInstance();
    const url = `/api/Evaluator/GetEvaluatorNameById/${id}?clearCache=false`;
    return authService.CallBackendFunction(url);
  }
}
